import { render, staticRenderFns } from "./user_mng.vue?vue&type=template&id=52ba95e6&"
import script from "./user_mng.vue?vue&type=script&lang=js&"
export * from "./user_mng.vue?vue&type=script&lang=js&"
import style0 from "./user_mng.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports